import { Link, useLocation } from "react-router-dom";
import LOGO from "../assets/images/logo.webp";
import { useEffect, useState } from "react";

export default function CSNav2() {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  // دالة لغلق القائمة
  const closeMenu = () => setIsOpen(false);

  // غلق القائمة عند التمرير
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        closeMenu();
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <nav
        dir="ltr"
        className="navbar navbar-expand-lg bg-body-tertiary cu-nav fixed-top"
      >
        <div className="container">
          <Link className="navbar-brand" to={"/"}>
            <div className="logo nav-logo">
              <Link to={"/"}>
                {/* إضافة خاصية التحميل الكسول هنا */}
                <img src={LOGO} alt="Logo" loading="lazy" width={"15rem"} />
              </Link>
            </div>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={isOpen ? "true" : "false"}
            aria-label="Toggle navigation"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  to={"/contact"}
                  className={`nav-link ${pathname === "/contact" && "active"}`}
                  onClick={closeMenu}
                  aria-current="page"
                >
                  تواصل معنا
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to={"/"}
                  className={`nav-link ${pathname === "/" && "active"}`}
                  onClick={closeMenu}
                  aria-current="page"
                >
                  الرئيسية
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
